import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import { Spin, Icon } from 'antd';

import Map from '../../shared/components/Map'; 

//import { List, Button, Modal } from 'antd';
import { ActionButton } from '../../shared/components/ActionButton';

import {setSearchTerm} from '../../shared/geocode/geocodeActions';

import {setBounds, setCenter} from '../../shared/actions';
import { setFenceUpdated, 
        serverMarkPOIValidationStageComplete, 
        serverArchivePOI, serverMarkPOIUnsure } from '../actions';

import { resetPOI, serverLoadPOI } from '../../pois/actions';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const red = '#D0021B';
const green = '#03DAC4';
const yellow ='#F0DA3B';

class ValidationPOIOrganization extends React.Component{
    // Event handlers
    componentWillMount(){
        let poiId = this.props.match.params.poi_id;
        this.props.getPoi(poiId);
    }

    componentDidMount(){
        let poiId = this.props.match.params.poi_id;
        this.context.mixpanel.track('validation', {
            task: 'poiOrganization',
            poiId,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.poi_id !== this.props.match.params.poi_id) {
            let poiId = nextProps.match.params.poi_id;
            nextProps.getPoi(poiId);
        }
    }
    
    render(){
        const { props } = this;

        let poiId = props.match.params.poi_id;

        const tmp = props.poiInfo.get(poiId);

        if (_.isUndefined(tmp)) {
            return(
                <div style={{ textAlign: 'center', verticalAlign: 'center', paddingTop: '30%' }}>
                    <Spin indicator={antIcon} />
                </div>
            )
        }
        const poi = tmp.poi;

        const fences = [];

        return(
                <div style={{ width: '100%', height: '100%', padding: '15px 20px', overflowY: 'scroll' }}>
                    <div style={{width: '100%', height: '50vh'}}>
                        <Map {...props} pois={[poi]} drawOnlyTopFence={false} fences={fences} showGeocode={false} drawMode={false} />
                    </div>
                    <div style={{ padding: "10px 0px" }}>
                        <span className="field">
                            <span className="label">POI name</span>
                            <h4 className="heading-level-2">{poi.name}</h4>
                        </span>
                        <p className="inline-content">{poi.formattedAddress}</p>
                    </div>
                    <div>
                        <div>
                            <span className="field">
                                <span className="label">Organization</span>
                                <span className="value">{poi.organizationName}</span>
                            </span>
                            {/*
                            <span className="field">
                                <span className="label">Subcategories</span>
                                <span className="value">Quick Service Restaurant</span>
                                <span className="value">Fast Food</span>
                            </span>

                            <span className="field">
                                <span className="label">Categories</span>
                                <span className="value">Food and Beverage</span>
                            </span>
                            */}
                        </div>
                        <div className="button-group">
                            <ActionButton 
                                style={{ backgroundColor: red}}
                                onClick={() => {
                                    props.archivePOI(poiId);
                                }}>
                                Incorrect
                            </ActionButton>
                            <ActionButton 
                                style={{ backgroundColor: yellow}}
                                onClick={() => {
                                    props.markPOIUnsure(poiId);
                                }}>
                                Unsure
                            </ActionButton>

                            <ActionButton 
                                style={{ backgroundColor: green}}
                                onClick={() => {
                                    props.markAsValidated(poiId);
                                }}>
                                Correct
                            </ActionButton>
                        </div>
                    </div>
                </div>
            )
        }
}


ValidationPOIOrganization.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      'poi_id': PropTypes.string,
    })
  }),
  poiInfo: PropTypes.instanceOf(Immutable.Map),
  duplicatePois: PropTypes.array,
  setMapBounds: PropTypes.func,
  getPoi: PropTypes.func,
  markAsValidated: PropTypes.func,
  archivePOI: PropTypes.func,
  markPOIUnsure: PropTypes.func,
}

ValidationPOIOrganization.contextTypes = {
    mixpanel: PropTypes.object.isRequired,
};

// Map props to the store

const mapStateToProps = (state) => ({
  mapCenter: state.common.getIn(['center']),
  mapBounds: state.common.getIn(['bounds']),
  poiInfo: state.routes.pois.server.get('poisMap'),
  drawMode: true,
  editMode: true,
  draggableMarkers: false,
  key: 'fenceEditMap',
});

const mapDispatchToProps = (dispatch) => ({
  newFenceDrawn: (newFence) => {
    dispatch(setFenceUpdated({
      type: newFence.geometry.type,
      coordinates: newFence.geometry.coordinates,
    }));
  },
  centerChanged: ()=>{
    dispatch(setCenter(null));
  },
  updateSearchTerm: (searchTerm) => {
    dispatch(setSearchTerm(searchTerm));
  },
  setMapBounds: (bounds) => {
    dispatch(setBounds(bounds));
  },
  getPoi: (poiId) => {
    dispatch(resetPOI(poiId));
    dispatch(serverLoadPOI(poiId));
  },
  markAsValidated: (poiId) => {
      dispatch(serverMarkPOIValidationStageComplete(poiId, 'validOrganization'));
  },
  archivePOI: (poiId) => {
      dispatch(serverArchivePOI(poiId));
  },
  markPOIUnsure: (poiId) => {
      dispatch(serverMarkPOIUnsure(poiId));
  },
})

const ValidationPOIOrganizationContainer = connect(mapStateToProps,mapDispatchToProps)(ValidationPOIOrganization);

export default ValidationPOIOrganizationContainer;



// WEBPACK FOOTER //
// ./src/validation/components/ValidationPOIOrganization.js